export default "__VITE_ASSET__CWnYg9Pf__"